<template>
	<div ref="scrollTarget" class="office-search">
		<p class="office-search-title">{{headline}}</p>
		<p class="office-search-label">Your zip code or city, state</p>
		<div class="office-search-form">
			<input type="text" class="office-search-input" v-model="search" v-on:keyup.enter="updateFilters" />
			<div class="office-search-btn" @click="updateFilters" v-on:keyup.enter="updateFilters"></div>
		</div>
		<p class="office-search-no-results" v-if="listing.length == 0 && isDoneSearch">Sorry, we couldn't find any locations for this search.</p>
		<p class="office-search-error" v-if="isInputValid"><i class="far fa-times"></i> Please enter a valid 5-digit zip code or city and state.</p>
		<div class="office-search-results" v-if="listing.length > 0">
			<search-result v-for="(item, key) in listing" v-bind:item="item" v-bind:key="key"></search-result>
		</div>
		<a class="office-search-show-more" @click="updatePagination" v-if="currentStep <= paginationTotal && listing.length > 0 && getMore">Show More</a>
		<div class="office-search-location-btn" v-if="hasGeolocationPermissions && listing.length <= 0" @click="geolocation">Use my current location</div>
	</div>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import he from 'he';
	import { mapState, mapActions, mapMutations } from 'vuex';
	import SearchResult from '../components/search/office-search-item.vue';

	export default {
		props: ['result', 'resource', 'headline'],
		data: function () {
			return {
				search: "",
				hasGeolocationPermissions: true,
				showingResults: [],
				currentStep: 4,
				isInputValid: false,
				isDoneSearch: false,
				getMore: true,
				timesShowMoreClicked: 0
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			paginationTotal: state => state.listing.pagination.total
		}),
		components: {
			'search-result': SearchResult
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);
			this.handleGeolocationState();

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/setListing') {
                    this.handleEmptySearch();
                }
            });
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
			...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			resetFilters() {
				this.resetSpecification();
			},
			scrollToTarget(anchorScrollBottom) {
				setTimeout(() => {
					if (this.$refs.scrollTarget !== undefined) {
						this.$refs.scrollTarget.scrollIntoView({ behavior: 'smooth', block: (anchorScrollBottom ? 'end' : 'center'), inline: 'end' });
					}
				}, 350);
			},
			updateFilters() {
				this.resetSpecification();
				this.isDoneSearch = false;
				this.currentStep = 4;
				this.timesShowMoreClicked = 0;
				this.getMore = true;
				if (this.search.length == 0) {
                    this.isInputValid = true;
                    return;
                }

                if (Number.isInteger(parseInt(this.search)) && (this.search.length < 5 || this.search.length > 5)) {
                    this.isInputValid = true;
                    return;
                }
				this.isInputValid = false;
				this.updateSpecification({ key: 'Query', value: he.decode(this.search) });
				this.scrollToTarget(false);
			},
			updatePagination() {
				this.timesShowMoreClicked += 1;
				if(this.timesShowMoreClicked > 2) {
					this.getMore = false;
				}
				this.currentStep += 4;
				this.updateSpecification({ key: 'PageSize', value: this.currentStep });
				this.scrollToTarget(true);
			},
			toggleGeolocationPermissionState(state) {
				if (state === 'granted') {
					this.hasGeolocationPermissions = true;
				} else if (state === 'denied') {
					this.hasGeolocationPermissions = false;
				} else if (state === 'prompt') {
					this.hasGeolocationPermissions = true;
				}
			},
			handleGeolocationState() {
				if (navigator.permissions) {
					navigator.permissions.query({ name: 'geolocation' }).then((result) => {
						this.toggleGeolocationPermissionState(result.state);

						result.onchange = () => {
							this.toggleGeolocationPermissionState(result.state);
						};
					});
				}
			},
			geolocation() {
				if (navigator.geolocation) {
					this.query = '';
					navigator.geolocation.getCurrentPosition(this.geolocationSuccess, this.handleGeolocationState());
				}
			},
			geolocationSuccess(position) {
				this.resetSpecification();
				this.isDoneSearch = false;
				this.updateSpecification({ key: 'Coords', value: JSON.stringify({ Latitude: position.coords.latitude, Longitude: position.coords.longitude }) });
			},
            handleEmptySearch() {
                if (this.listing.length == 0)
                {
                    this.isDoneSearch = true;
                }
            }
		}
	}
</script>